import type { Except, NonEmptyArray, Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { ActionData } from './types'

export type ActionsOverwrite = Except<ActionData, 'categories'> & {
  categories: NonEmptyArray<string>
}

type ActionContextProps = {
  onRegister: (action: ActionsOverwrite) => void
  onUnregister: (actionKey: ActionData['key']) => void
  currentId: Optional<string>
  /**
   * Opens the action by its `actionKey` (AKA `registrationId`).
   *
   * If you're trying to open a command data by its type, you should probably use `onOpenCreateCommandData`.
   */
  onOpen: (actionKey: string) => void
  /**
   * Opens the action by its `actionId` (*not* the `actionKey`.)
   *
   * This is mostly useful for `CommandModalButton` actions.
   * `CommandPaletteModalButton`s already have an `actionKey` that matches\* the `actionId`.
   *
   * If you're trying to open a command data by its type, you should probably use this.
   *
   * Note that this can only open the create variant without an `entityId`.
   * */
  onOpenCreateCommandData: (actionId: string) => void
  onClose: () => void
  actions: Map<string, ActionsOverwrite>
}

const [useActionsContext, ActionsContextProvider] =
  createRequiredContext<ActionContextProps>('ActionContext')

export { ActionsContextProvider, useActionsContext }
